const { PAYMENT_MODES } = require('common/constants');
const { PERKS_PAYMENT_OPTIONS } = require('common/constants/perks');

function isPerkPaymentModeSupported(perk, currency, paymentModeCurrencies) {
    if (perk.enableRegularPayments && !perk.enableRecurringPayments) {
        return paymentModeCurrencies[PAYMENT_MODES.REGULAR].includes(currency);
    }
    if (perk.enableRecurringPayments && !perk.enableRegularPayments) {
        return paymentModeCurrencies[PAYMENT_MODES.RECURRING].includes(
            currency,
        );
    }
    return true;
}

function getDefaultPaymentMode(perk, currency, paymentModeCurrencies) {
    if (!(perk.enableRecurringPayments && perk.enableRegularPayments)) {
        return perk.paymentOptions;
    }
    const regularSupported =
        paymentModeCurrencies[PAYMENT_MODES.REGULAR].includes(currency) > 0;
    const recurringSupported =
        paymentModeCurrencies[PAYMENT_MODES.RECURRING].includes(currency);
    if (!regularSupported && !recurringSupported) {
        return null;
    }
    if (perk.paymentOptions === PERKS_PAYMENT_OPTIONS.SINGLE) {
        return regularSupported
            ? PERKS_PAYMENT_OPTIONS.SINGLE
            : PERKS_PAYMENT_OPTIONS.RECURRING;
    }
    return recurringSupported
        ? PERKS_PAYMENT_OPTIONS.RECURRING
        : PERKS_PAYMENT_OPTIONS.SINGLE;
}

module.exports = {
    isPerkPaymentModeSupported,
    getDefaultPaymentMode,
};
